<template>
    <div class="row" v-if="string">
        <div class="col-md-12">
            <span class="FilterString hidden-xs hidden-sm" v-html="string"></span>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                string: this.current
            }
        },

        props: {
            current: {
                required: true,
                type: String
            },

            vehicleType: {
                required: true,
                type: String
            }
        },

        mounted() {
            bus.$on('update-filter-string', () => {
                this.updateString()
            })
        },

        methods: {
            updateString() {
                this.$http.post('/motorstats/filter-string', { type: this.vehicleType }).then((response) => {
                    this.string = response.data;
                });
            }
        },
    }
</script>